import React from "react";
import reactWrapper from "@harbor/elements/utils/react/wrapper";
import { useI18n } from "../../i18n/useI18n";

const [HbrBanner, HbrIcon] = reactWrapper(["hbr-banner", "hbr-icon"]);

const AIAssistantUnavailable = () => {
  const { tCommon } = useI18n("common");

  return (
    <HbrBanner
      data-testid="ai-assistant-unavailable"
      open
      sentiment="danger"
      variant="fill"
    >
      <HbrIcon slot="icon" name="alerts-negative-large" />
      {tCommon("aiAssistantUnavailable")}
    </HbrBanner>
  );
};

export default AIAssistantUnavailable;
